// import axios from 'axios'
import React, { useState } from 'react'
import AwsConfig from '../../Config/AwsConfig'

export default function Scrape() {
  const [uRl, setUrl] = useState([])
  const [moviePerson, setmoviePerson] = useState('')
  const [ScrapedData, setScrapedData] = useState([])
  const { ScrapeUrlV2 } = AwsConfig
  const sCrape = event => {
    // console.log(event.target.value, 'value')
    const Urls = event.target.value
    const arrayUrls = Urls.split('\n')
    // console.log(arrayUrls, 'arrayUrls')
    setUrl(arrayUrls)
  }

  const scrapeData = async () => {
    console.log('scrape')
    const raw = JSON.stringify({
      contentType: moviePerson,
      allURLs: uRl,
    })

    const requestOptions = {
      method: 'POST',
      body: raw,
      redirect: 'follow',
    }

    fetch(ScrapeUrlV2, requestOptions)
      .then(response => response.text())
      .then(result => {
        setScrapedData(result.split('======'))
      })
      .catch(error => console.log('error', error))
  }

  const handlemoviePersonChange = event => {
    setmoviePerson(event.target.value)
  }

  return (
    <div>
      <label>Scrape:</label>
      <div className='currentlyactive-style' style={{ display: 'flex', gap: '10px' }}>
        <input
          id='c1'
          type='radio'
          name='currently active'
          value='movies'
          checked={moviePerson === 'movies'}
          onChange={handlemoviePersonChange}
        />
        <label htmlFor='c1'>Movie</label>
        <input
          id='c2'
          type='radio'
          name='currently active'
          value='person'
          checked={moviePerson === 'person'}
          onChange={handlemoviePersonChange}
        />
        <label htmlFor='c2'>Person</label>
        <input
          id='c3'
          type='radio'
          name='currently active'
          value='company'
          checked={moviePerson === 'company'}
          onChange={handlemoviePersonChange}
        />
        <label htmlFor='c3'>company</label>
        <input
          id='c4'
          type='radio'
          name='currently active'
          value='webseries'
          checked={moviePerson === 'webseries'}
          onChange={handlemoviePersonChange}
        />
        <label htmlFor='c4'>webseries</label>
        <br></br>
      </div>
      <div>
        <textarea
          // value={uRl}
          onChange={event => sCrape(event)}
          style={{ width: '80%' }}
          className='rounded'
          rows={8}
          cols={50}
        />
      </div>
      <div></div>
      <br></br>
      <button
        type='button'
        className='btn btn-primary m-2'
        disabled={!(uRl && moviePerson)}
        onClick={() => scrapeData()}
      >
        Submit
      </button>
      <br></br>
      {ScrapedData.map((e, index) => (
        <div key={index}>
          {e}
          <br></br>
        </div>
      ))}
    </div>
  )
}
